import { mapGetters, mapState } from 'vuex';
import portfolioMyMarkets from '@/components/dashboard/portfolio-my-markets/portfolio-my-markets.vue';
import dashboardMarketFilters from '@/components/market/market-filters/market-filters-dashboard/market-filters-dashboard.vue';
import dashboardMarketsToggle from '@/components/dashboard/dashboard-markets-toggle/dashboard-markets-toggle.vue';

export default {
  components: {
    dashboardMarketFilters,
    portfolioMyMarkets,
    dashboardMarketsToggle,
  },
  computed: {
    ...mapGetters('dashboard', ['mySharesTotalGainLoss']),
    ...mapGetters('wallet', ['portfolioValueDecimal']),
    ...mapState('dashboard', ['mySharesReady']),
    ...mapState('wallet', ['balance']),
    portfolioValueReady() {
      return !this.balance.isDefault && this.mySharesReady;
    },
    gainLossClassModifiers() {
      const value = this.mySharesTotalGainLoss;
      return {
        'dashboard-portfolio__summary-item-value--plus': value > 0,
        'dashboard-portfolio__summary-item-value--minus': value < 0,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboard-portfolio/dashboard-portfolio.js